<app-card appVisible [visible$]="visible$">
  <div class="d-flex flex-column justify-content-center align-items-center text-center h-100">
    <h5><i class="bi" [class]="icon"></i>{{ title }}</h5>
    <div class="d-flex">
      @if ((data$ | async) !== undefined && !loading && !error) {
        <div class="container d-flex flex-wrap justify-content-center">
          <span class="value status-text" [style.color]="colorService.getColor(color)">
            {{ duration | appTimeSpan }}
          </span>
        </div>
      }

      @if (loading) {
        <div class="container placeholder-glow">
          <span class="value col-12">
            <div class="placeholder"></div>
          </span>
        </div>
      }
      @if (error) {
        <app-error-message [error]="error"></app-error-message>
      }
    </div>
    @if (infoText) {
      <span class="text-muted small">{{ infoText }}</span>
    }
  </div>
</app-card>
